import {animated, useSpring} from "@react-spring/web";
import {useState} from "react";
import DocsPage from "./DocsPage";

enum DocsState {
    General = 'General',
    Gameplay = 'Gameplay',
    Payments = 'Payments',
}

function DocsView() {
    const [state, setState] = useState<DocsState>(DocsState.General);

    return (
        <div className={'layout flex-grow gap-large docs-body'} style={{paddingTop: 'var(--box-padding)'}}>
            <div className={'layout vertical gap'} style={{width: '100%'}}>
                {Object.values(DocsState).map((doc: DocsState, idx: number) => {
                    return <StateButton i={idx} state={doc} curState={state} onClick={setState}/>
                })}
            </div>
            {state === DocsState.General && <DocsPage path={'./docs/general.md'}/>}
            {state === DocsState.Gameplay && <DocsPage path={'./docs/gameplay.md'}/>}
            {state === DocsState.Payments && <DocsPage path={'./docs/payments.md'}/>}
        </div>
    )
}

function StateButton(params: {i: number, state: DocsState, curState: DocsState, onClick(state: DocsState): void}) {
    const springs = useSpring({
        delay: params.i * 200,
        from: { x: -30, opacity: 0 },
        to: { x: 0, opacity: 1 },
    })

    return (
        <animated.div style={{
            ...springs
        }}>
            <button className={`docs-button tab-button ${params.state === params.curState ? '' : 'inactive'}`}
                    onClick={() => params.onClick(params.state)}>
                {params.state}
            </button>
        </animated.div>
    )
}

export default DocsView;
